import Accordion from "components/accordion/Accordion";
import DailyReportCard from "components/card/DailyReportCard";
import { CreateAppealRequestPopup } from "components/pop-up/AppealRequest";
import { useMemo, useState } from "react";

import { AssetAppeal, Report } from "types";

export default function RespondentReportList({
  appealId,
  fileRowProps,
  reports,
  recoveryReports,
  appeal,
}: {
  appealId?: string;
  fileRowProps: any;
  reports: Report[];
  recoveryReports: Report[];
  appeal?: AssetAppeal;
}) {
  // Filter reports by type
  const appealDailyReports = reports?.filter(
    (report) => !report.is_next_appointment_reason_final_verdict,
  );
  const appealFinalVerdicts = reports?.filter(
    (report) => report.is_next_appointment_reason_final_verdict,
  );

  const allFinalReportAssets = useMemo(() => {
    const assets: any[] = [];
    appealFinalVerdicts.forEach((report) => {
      if (report.asset) {
        if (Array.isArray(report.asset)) {
          assets.push(...report.asset);
        } else if (typeof report.asset === "object") {
          assets.push(report.asset);
        }
      }
    });
    return assets;
  }, [appealFinalVerdicts]);

  const [isAppealPopupOpen, setIsAppealPopupOpen] = useState<{
    open: boolean;
    data: any;
  }>({ open: false, data: null });
  return (
    <div className="max-w-3xl bg-gray-50 rounded-xl shadow-sm w-[55%] p-2 mt-2">
      <div className="space-y-2">
        {/* Prohibition Daily Reports */}
        {appealDailyReports?.length > 0 && (
          <Accordion
            title={`Appeal Daily Reports (${appealDailyReports?.length})`}
            mainTitle=""
          >
            <div className="space-y-2">
              {appealDailyReports.map((report, index) => (
                <Accordion
                  key={report.id}
                  title={`Daily Report - ${new Date(
                    report.court_hearing_date,
                  ).toLocaleDateString(undefined, {
                    weekday: "long",
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                  })}`}
                  mainTitle=""
                >
                  <DailyReportCard
                    key={report.id || index}
                    report={report}
                    fileRowProps={fileRowProps}
                    prohibitionId={report.prohabition_request}
                  />
                </Accordion>
              ))}
            </div>
          </Accordion>
        )}

        {/* Prohibition Final Verdicts */}
        {appealFinalVerdicts?.length > 0 && (
          <Accordion
            title={`Appeal Final Verdicts (${appealFinalVerdicts?.length})`}
            mainTitle=""
          >
            <div className="space-y-2">
              {appealFinalVerdicts.map((report, index) => (
                <Accordion
                  key={report.id}
                  title={`Final Verdict - ${new Date(
                    report.court_decision_date as string,
                  ).toLocaleDateString(undefined, {
                    weekday: "long",
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                  })}`}
                  mainTitle=""
                >
                  <DailyReportCard
                    key={report.id || index}
                    report={report}
                    fileRowProps={fileRowProps}
                    isAppeal={true}
                    setIsAppealPopupOpen={setIsAppealPopupOpen}
                    appealId={appealId}
                    appeal={appeal}
                    prohibitionId={report.prohabition_request}
                  />
                </Accordion>
              ))}
            </div>
          </Accordion>
        )}

        {/* No Reports Message */}
        {reports?.length === 0 && recoveryReports.length === 0 && (
          <p>No Reports Added</p>
        )}
      </div>
      <CreateAppealRequestPopup
        referralId={appeal?.asset_referral?.id as string}
        data={isAppealPopupOpen.data}
        isOpen={isAppealPopupOpen.open}
        onClose={() => setIsAppealPopupOpen({ open: false, data: null })}
        allAssets={allFinalReportAssets}
      />
    </div>
  );
}
